"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_options_preview_scales_html_1 = __importDefault(require("./global-options-preview-scales.html"));
(function (module) {
    'use strict';
    var DIAMETER_TO_LABEL_RATIO = 1 / 4;
    var DIAMETER_TO_PERCENT_RATIO = 1 / 8;
    var DEFAULT_DONUT_RATIO = 0.84;
    var LABEL_COLOR = 'black';
    var LABEL_WEIGHT = 600;
    var CONTAINER_ID = 'global-options-preview-scales';
    var CUSTOM = 'Custom';
    function GlobalOptionsPreviewScalesController($scope, $timeout, scaleColorPaletteService, ColorPalette) {
        this.$timeout = $timeout;
        this.scaleColorPaletteService = scaleColorPaletteService;
        this.ColorPalette = ColorPalette;
        var self = this;
        this.unsub = $scope.$watchCollection('[$ctrl.scaleColorPalette.name, $ctrl.scaleColorPalette.isReversed, $ctrl.customPalette.colors]', function () {
            self.renderChart();
        });
    }
    GlobalOptionsPreviewScalesController.prototype.$onInit = function () {
        this.renderChart();
    };
    GlobalOptionsPreviewScalesController.prototype.$onDestroy = function () {
        this.clearChart();
        this.unsub();
    };
    GlobalOptionsPreviewScalesController.prototype.clearChart = function () {
        if (this.chart && this.chart.remove) {
            this.chart.remove();
            this.chart = null;
        }
    };
    GlobalOptionsPreviewScalesController.prototype.renderChart = function () {
        this.chart = this.chart || new window.dq.Chart.RoundChart({
            containerId: CONTAINER_ID
        });
        var dqData = this._getData();
        var self = this;
        this.$timeout(function () {
            var label = Math.round(dqData[0].value);
            var diameter = self._getDiameter();
            var labelSize = diameter * DIAMETER_TO_LABEL_RATIO;
            var percentSize = diameter * DIAMETER_TO_PERCENT_RATIO;
            self.chart
                .setLabel(label, LABEL_COLOR, labelSize, LABEL_WEIGHT)
                .setData(dqData)
                .showPercentage(true, percentSize)
                .setDonutRatio(DEFAULT_DONUT_RATIO)
                .render();
        });
    };
    GlobalOptionsPreviewScalesController.prototype._getDiameter = function () {
        if (_.isEmpty(this.container)) {
            this.container = $('#' + CONTAINER_ID);
        }
        return Math.min(this.container.height(), this.container.width());
    };
    GlobalOptionsPreviewScalesController.prototype._getData = function () {
        var palette;
        if (this.scaleColorPalette.name === CUSTOM) {
            palette = new this.ColorPalette(this.customPalette.colors, this.scaleColorPalette.startIndex, this.scaleColorPalette.isReversed);
        }
        else {
            palette = this.scaleColorPaletteService.getColorPalette(this.scaleColorPalette);
        }
        this.unfavorable = palette.getNext();
        this.neutral = palette.getNext();
        this.favorable = palette.getNext();
        // These are random numbers to use for this preview
        return [
            {
                value: 62.3,
                color: this.favorable
            },
            {
                value: 12.8,
                color: this.neutral
            },
            {
                value: 23.9,
                color: this.unfavorable
            }
        ];
    };
    GlobalOptionsPreviewScalesController.$inject = [
        '$scope',
        '$timeout',
        'widget.componentBase.scaleColorPaletteService',
        'widget.componentBase.ColorPalette'
    ];
    module.component('prGlobalOptionsPreviewScales', {
        templateUrl: global_options_preview_scales_html_1.default,
        controller: GlobalOptionsPreviewScalesController,
        bindings: {
            scaleColorPalette: '<',
            customPalette: '<',
            widgetPadding: '<'
        }
    });
})(angular.module('qualtrics.pr'));
